import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createFocusTrap } from 'focus-trap';
import Cookies from 'js-cookie';

export default class CTAModal {

	constructor(element) {
		this.handleTriggerClick = this.handleTriggerClick.bind(this);
		this.handleCloseClick = this.handleCloseClick.bind(this);
		this.handleNavMenuLinkClick = this.handleNavMenuLinkClick.bind(this);
		this.element = element;
		this.openClass = 'gigs-cta-modal--open';
		this.successClass = 'gigs-cta-modal--success';
		this.closeButton = (this.element instanceof HTMLElement) ? this.element.querySelector('.gigs-cta-modal__close') : undefined;
		this.navMenuLinks = (this.element instanceof HTMLElement) ? this.element.querySelectorAll('.gigs-cta-modal__navigation .menu-item > a') : [];
		this.overlay = (this.element instanceof HTMLElement) ? this.element.querySelector('.gigs-cta-modal__overlay') : undefined;
		this.autoshow = (this.element instanceof HTMLElement) ? this.element.getAttribute('data-autoshow') === 'true' : false;
		this.openTimeout = (this.element instanceof HTMLElement) ? this.element.getAttribute('data-autoshow-timeout') : undefined;
		this.openTimer = undefined;
		this.seenCookie = (this.element instanceof HTMLElement) ? this.element.getAttribute('data-cookie-name') : undefined;
		this.blocklist = (this.element instanceof HTMLElement) ? JSON.parse( this.element.getAttribute('data-blocklist') || '[]' ) : [];
		this.triggerQuery = (this.element instanceof HTMLElement) ? `a[href="#${this.element.id}"]` : '';
		this.seenCookieOptions = {
			expires: 365, // days
		};
		this.focusTrap = null;
		this.wpAdminBar = document.getElementById('wpadminbar');
		this.focusableElements = [this.element];
		if (this.wpAdminBar) this.focusableElements.push(this.wpAdminBar);
	}

	init() {
		if (this.closeButton instanceof HTMLElement) {
			this.closeButton.addEventListener('click', this.handleCloseClick);
		}
		if (this.overlay instanceof HTMLElement) {
			this.overlay.addEventListener('click', this.handleCloseClick);
		}
		if (this.navMenuLinks.length > 0) {
			this.navMenuLinks.forEach(link => {
				if (link instanceof HTMLElement) {
					link.addEventListener('click', this.handleNavMenuLinkClick);
				}
			});
		}
		this.initTriggers();
		this.initFocusTrap();
		if (this.shouldAutoShow()) {
			this.setTimeout();
		}
	}

	shouldAutoShow() {
		const hasSeenCookie = this.hasSeenCookie();
		const isPathBlocked = this.blocklist.some((path) => {
			const regex = new RegExp(path);
			return regex.test(window.location.pathname);
		});
		return ! hasSeenCookie && ! isPathBlocked;
	}

	destroy() {
		if (this.closeButton instanceof HTMLElement) {
			this.closeButton.removeEventListener('click', this.handleCloseClick);
		}
		if (this.overlay instanceof HTMLElement) {
			this.overlay.removeEventListener('click', this.handleCloseClick);
		}
		if (this.navMenuLinks.length > 0) {
			this.navMenuLinks.forEach(link => {
				if (link instanceof HTMLElement) {
					link.removeEventListener('click', this.handleNavMenuLinkClick);
				}
			});
		}
		this.clearTimeout();
		this.destroyTriggers();
		this.destroyFocusTrap();
	}

	initFocusTrap() {
		this.focusTrap = createFocusTrap(this.focusableElements, {
			onDeactivate: () => this.close(),
		});
	}

	destroyFocusTrap() {
		if (this.focusTrap) {
			this.focusTrap.deactivate();
			this.focusTrap = null;
		}
	}

	initTriggers(container) {
		container = (container instanceof HTMLElement) ? container : document;
		if (this.triggerQuery) {
			const triggers = container.querySelectorAll(this.triggerQuery);
			triggers.forEach(trigger => {
				trigger.addEventListener('click', this.handleTriggerClick);
			});
		}
	}

	destroyTriggers(container) {
		container = (container instanceof HTMLElement) ? container : document;
		if (this.triggerQuery) {
			const triggers = container.querySelectorAll(this.triggerQuery);
			triggers.forEach(trigger => {
				trigger.removeEventListener('click', this.handleTriggerClick);
			});
		}
	}

	handleTriggerClick(e) {
		e.preventDefault();
		this.open();
	}

	open() {
		if (this.element instanceof HTMLElement) {
			this.element.classList.add(this.openClass);
			this.focusTrap.activate();
			disableBodyScroll(this.element);
		}
	}

	close() {
		if (this.element instanceof HTMLElement) {
			this.setSeenCookie();
			this.focusTrap.deactivate();
			this.element.classList.remove(this.openClass);
			enableBodyScroll(this.element);
		}
	}

	setTimeout() {
		this.clearTimeout();
		if (this.autoshow) {
			this.openTimer = window.setTimeout(() => this.open(), Number(this.openTimeout || 0));
		}
	}

	clearTimeout() {
		if (this.openTimer) window.clearTimeout(this.openTimer);
	}

	hasSeenCookie() {
		return (this.seenCookie && Boolean(Cookies.get(this.seenCookie)));
	}

	setSeenCookie() {
		if (this.seenCookie) {
			Cookies.set(this.seenCookie, '1', this.seenCookieOptions);
		}
	}

	handleCloseClick(e) {
		e.preventDefault();
		this.close();
	}

	handleNavMenuLinkClick(e) {
		this.close();
	}
}
